import * as yup from 'yup'
import type {
  MerchantListDetails,
  MerchantListDetailsSchema,
  MerchantListTypeOption,
} from './types'

export const useMerchantListEditModal = (
  listDetails: MerchantListDetails,
  listTypeOptions?: MerchantListTypeOption[]
) => {
  const { id: listId, name, type } = listDetails

  let initialType = type
  let typeSchema = yup.string().required()
  if (listTypeOptions) {
    const typeValues = listTypeOptions.map(listType => listType.value)
    initialType = typeValues.includes(type) ? type : typeValues[0]
    typeSchema = yup.string().required().oneOf(typeValues)
  }

  const validationSchema: yup.SchemaOf<MerchantListDetailsSchema> = yup.object({
    name: yup.string().optional().default(''),
    type: typeSchema,
  })

  return {
    listId,
    initialValues: { name, type: initialType } as MerchantListDetailsSchema,
    validationSchema,
  }
}
